import Header from './Headers';

import Config from '../config/config';
import Const from '../util/Constants';

class AutoReportAPI {
  
  static list = (success, failure) => {
    const body = { filter: [], page: 1, perPage: 1000 };
    fetch(Config.app.link + 'api/auto_report/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (dist, success, failure) => {
    fetch(Config.app.link + 'api/auto_report/add-edit', new Header('POST', dist))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/auto_report/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default AutoReportAPI;